import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const whatwedocardui = css({
  background: '#fff',
  paddingTop: 40,

  a: {
    textDecoration: 'none',
  },

  '.main_img': {
    img: {
      height: '221px',
      width: '295px',
      objectFit: 'cover',
    },
  },

  '.logo_img': {
    background: '#ffffff',
    padding: '8px 16px',
    marginTop: '-45px',
    width: '257px',
    position: 'relative',
    [MediaQueries.sm]: { maxHeight: '100px' },
  },

  '.textp': {
    p: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1.5',
      color: '#888888',
      textDecoration: 'NONE',
    },
  },

  [MediaQueries.sm]: {},
  [MediaQueries.md]: {
    // width: '263px !important',
  },

  h3: {
    fontSize: '33px',
    lineHeight: '40px',
    minHeight: '160px',
    letterSpacing: '0px',
    textAlign: 'left',
    fontWeight: '500',
    marginBottom: '16px',
    marginTop: '18px',
  },

  p: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    minHeight: '96px',
    letterSpacing: '0px',
    textAlign: 'left',
    color: '#747475',
  },

  '.findoutlink': {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '32px',
    position: 'absolute',
    bottom: '40px',
    [MediaQueries.sm]: { position: 'relative', bottom: 'unset' },
    'a:first-child': {
      marginBottom: '24PX',
    },
    a: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#E52500',
      textDecoration: 'none',

      'span:first-child': {
        borderBottom: '#FAD3CC solid 1px',
        paddingBottom: '5px',
      },

      i: {
        fontSize: '10px',
        marginLeft: '16px',
      },
    },
  },
});

export const setHeightlight = highlightColor =>
  css({
    h3: {
      span: {
        color: highlightColor,
      },
    },
  });
